// Mirrors the categories produced by backend/src/utils/errorClassifier.js.
export const ERROR_CATEGORIES = [
    { value: 'EMAIL', label: 'Email', color: '#8b5cf6' },
    { value: 'DATABASE', label: 'Database', color: '#dc2626' },
    { value: 'DATA', label: 'Data conflict', color: '#f97316' },
    { value: 'VALIDATION', label: 'Validation', color: '#eab308' },
    { value: 'FILE_UPLOAD', label: 'File upload', color: '#0ea5e9' },
    { value: 'NETWORK', label: 'Network', color: '#6366f1' },
    { value: 'FILESYSTEM', label: 'File system', color: '#64748b' },
    { value: 'UNCLASSIFIED', label: 'Unclassified', color: '#6b7280' },
];

export const categoryMeta = (value) =>
    ERROR_CATEGORIES.find(c => c.value === value) || { value, label: value, color: '#6b7280' };

// Sources are derived from the API route (e.g. /api/leaves -> LEAVES), plus
// the fixed sources logSystemEvent callers use.
export const LOG_SOURCES = [
    'AUTH', 'ADMIN', 'API', 'JOB', 'PLATFORM',
    'LEAVES', 'EXPENSES', 'HOLIDAYS', 'PAYROLL', 'ATTENDANCE', 'WORKFLOW', 'DEPARTMENTS', 'LOGS',
];
